/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request for an appointmentType
 * @export
 * @interface AppointmentTypeRequest
 */
export interface AppointmentTypeRequest {
    /**
     * Unique identifier of the appointment type
     * @type {string}
     * @memberof AppointmentTypeRequest
     */
    appointmentTypeId?: string | null;
    /**
     * Name of appointment type
     * @type {string}
     * @memberof AppointmentTypeRequest
     */
    name?: string;
    /**
     * Status offline of appointment type
     * @type {string}
     * @memberof AppointmentTypeRequest
     */
    offline?: string;
    /**
     * Number of duration base
     * @type {number}
     * @memberof AppointmentTypeRequest
     */
    duration?: number;
    /**
     * Appointment types order
     * @type {number}
     * @memberof AppointmentTypeRequest
     */
    order?: number;
    /**
     * Additional information
     * @type {string}
     * @memberof AppointmentTypeRequest
     */
    note?: string;
    /**
     * UUID of the appointment color to link
     * @type {string}
     * @memberof AppointmentTypeRequest
     */
    color?: string;
}

/**
 * Check if a given object implements the AppointmentTypeRequest interface.
 */
export function instanceOfAppointmentTypeRequest(value: object): value is AppointmentTypeRequest {
    return true;
}

export function AppointmentTypeRequestFromJSON(json: any): AppointmentTypeRequest {
    return AppointmentTypeRequestFromJSONTyped(json, false);
}

export function AppointmentTypeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentTypeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'appointmentTypeId': json['appointmentTypeId'] == null ? undefined : json['appointmentTypeId'],
        'name': json['name'] == null ? undefined : json['name'],
        'offline': json['offline'] == null ? undefined : json['offline'],
        'duration': json['duration'] == null ? undefined : json['duration'],
        'order': json['order'] == null ? undefined : json['order'],
        'note': json['note'] == null ? undefined : json['note'],
        'color': json['color'] == null ? undefined : json['color'],
    };
}

export function AppointmentTypeRequestToJSON(json: any): AppointmentTypeRequest {
    return AppointmentTypeRequestToJSONTyped(json, false);
}

export function AppointmentTypeRequestToJSONTyped(value?: AppointmentTypeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointmentTypeId': value['appointmentTypeId'],
        'name': value['name'],
        'offline': value['offline'],
        'duration': value['duration'],
        'order': value['order'],
        'note': value['note'],
        'color': value['color'],
    };
}

